<template>
  <app-modal-row class="mb-8">
    <app-modal-col cols="8">
      <app-autocomplete
        class="ma-0 pa-0"
        v-model="copy_cdb_from"
        :items="cdbs_with_settings"
        label="Empresas"
        item-text="name"
        item-value="id"
        hide-no-data
        hide-selected
        hide-search
        hide-details
      ></app-autocomplete>
    </app-modal-col>
    <app-modal-col cols="4" class="d-flex align-center justify-end">
      <app-btn
        :disabled="!copy_cdb_from"
        :loading="copying"
        @click="$emit('copy-settings',copy_cdb_from)"
        >
          Copiar
        </app-btn>
    </app-modal-col>
  </app-modal-row>
</template>

<script>
import { mapActions } from "vuex";
import { mapFields } from 'vuex-map-fields';
import AppAutocomplete from "@/components/layout/AppAutocomplete.vue";
import AppBtn from "@/components/layout/AppBtn.vue";
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';

export default ({
    name: 'CopySettings',

    components: {
      AppAutocomplete,
      AppBtn,
      AppModalCol,
      AppModalRow,
    },

    props:{
        cdb_id: {
            type: [String,Number],
            required: true,
        },
        code: {
            type: String,
            required: true,
        },
        copying: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            copy_cdb_from: 0,
        }
    },
    computed: {
        ...mapFields('connector', {
            cdbs_with_settings: 'cdbs_with_settings',
        }),
    },
    methods:{
        ...mapActions({
            getCdbWithSettings: 'connector/getCdbWithSettings',
        }),
    },
    mounted(){
        this.getCdbWithSettings({'settings_code':this.code,'cdb_id':this.cdb_id});
    },
})
</script>
